module.exports = __webpack_public_path__ + "img/home-1.0515a6ca.png";